import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageStatusUpdate from "../components/ComplainFormPageStatusUpdate";

const ComplainFormStatusUpdate = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <div>
      <MasterLayout>
        <ComplainFormPageStatusUpdate  complainId={id} />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormStatusUpdate;
